<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__restriction' : 'collapsible collapsed collapsible__restriction'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getRestrictionImage(restrictionTypeId)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">{{LaneClosureRequest.getDirectionText(directionId)}} {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}}</div>
								<div class="collapsible-heading__status" @click="onToggleExpand"><div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div></div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseRestrictionListing" @click="onToggleExpand">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
						<b-collapse id="collapseRestrictionListing" :visible="expand" class="collapsible-entries">

							<div v-for="(p, uindex) in preset[0].restriction" v-if="p.restrictionTypeId.value == restrictionTypeId && p.directionId.value == directionId" class="collapsible-unique">
								<div class="collapsible-entry__details">
									<div v-html="getPeakReasonText(uindex)"></div>
								</div>
								<div v-if="canBeAdded(b2index,uindex)" v-for=" (b, b2index) in value" :key="'blr2index'+b2index+'-'+renderCounter">
									<div v-for="(l2, l2index) in b.restriction" v-if="isEntry(b2index,directionId,uindex,l2.crossStreet.value, l2index)" :class="flexClasses(b2index)" :key="'blr2lindex'+l2index+renderCounter">
										<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index, uindex, l2.crossStreet.value)"></div>
										<div class="flex-grow-1 ">
											<div class="d-flex collapsible-entry__title-wrapper">
												<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId, l2.crossStreet.value)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span> {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}} onto <span>{{l2.crossStreet.value}}</span></a></div>
												<div class="collapsible-entry__map-button">
													<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, l2.crossStreet.value)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>
					<!-- end of desktop -->
					<div v-if="$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__restriction' : 'collapsible collapsed collapsible__restriction'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getRestrictionImage(restrictionTypeId)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
									{{LaneClosureRequest.getDirectionText(directionId)}} {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}}
								</div>
								<div @click="onToggleExpand" class="collapsible-heading__effect">
									<div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
								</div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table-cell pr-2' : 'flex-table-cell collapsed pr-2'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseRestrictionListing" @click="onToggleExpand">
											<span>
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="$store.state.isMobile && expand">
						<transition  name="slide-fade" tag="div">
						<div class="d-block section-slide-panel review-step" v-if="showPanel">
								<div class="top-controls">
									<button type="button" @click="onApply">
										<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
									</button>
								</div>
								<div class="panels-body panels-body-padded">
									<div class="panels-nav-title" v-html="getNavTitle"></div>
									<div class="panels-primary-title" v-html="getModalTitle"></div>
									<div class="d-flex" v-if="false"><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-close.svg" alt="" /><span class="status-circle__label">In Place</span></div><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-open.svg" alt="" /><span class="status-circle__label">Removed</span></div><div class="lcr-summary__status-legend"><span class="status-circle r-not-reported"></span><span class="status-circle__label"> Not Reported</span></div></div>
									<div class="panels-body-content">
									<div v-for="(p, uindex) in preset[0].restriction" v-if="p.restrictionTypeId.value == restrictionTypeId && p.directionId.value == directionId" class="collapsible-unique">
										<div class="collapsible-entry__details">
											<div v-html="getPeakReasonText(uindex)"></div>
										</div>
										<div class="collapsible-entry__wrapper" v-if="canBeAdded(b2index,uindex)" v-for=" (b, b2index) in value" :key="'blr2index'+b2index+'-'+renderCounter">
											<div class="collapsible-entry d-flex" v-for="(l2, l2index) in b.restriction" v-if="isEntry(b2index,directionId,uindex,l2.crossStreet.value, l2index)" :key="'blr2lindex'+l2index+renderCounter">
												<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index, uindex, l2.crossStreet.value)"></div>
												<div class="flex-grow-1 ">
													<div class="d-flex collapsible-entry__title-wrapper">
														<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId, l2.crossStreet.value)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span> {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}} onto <span>{{l2.crossStreet.value}}</span></a></div>
														<div class="collapsible-entry__map-button">
															<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, l2.crossStreet.value)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									</div>
								</div>
								<div v-if="false" class="panels-apply">
									<div class="d-flex">
										<div class="panels-apply__back"><b-button @click="onApply" variant="text" class="btn-cancel" type="button">Back</b-button></div>
									</div>
								</div>

							</div>
						</transition>
					</div>


					<div v-if="1 == 2 && $store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__restriction' : 'collapsible collapsed collapsible__restriction'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getRestrictionImage(restrictionTypeId)"></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
									{{LaneClosureRequest.getDirectionText(directionId)}} {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}}
								</div>
								<div @click="onToggleExpand" class="collapsible-heading__effect">
									<div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
								</div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible" :class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'" :aria-expanded="expand ? 'true' : 'false'" aria-controls="collapseRestrictionListing" @click="onToggleExpand">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
						<b-collapse id="collapseRestrictionListing" :visible="expand" class="collapsible-entries">

							<div v-for="(p, uindex) in preset[0].restriction" v-if="p.restrictionTypeId.value == restrictionTypeId && p.directionId.value == directionId" class="collapsible-unique">
								<div class="collapsible-entry__details">
									<div v-html="getPeakReasonText(uindex)"></div>
								</div>
								<div class="collapsible-entry__wrapper" v-if="canBeAdded(b2index,uindex)" v-for=" (b, b2index) in value" :key="'blr2index'+b2index+'-'+renderCounter">
									<div class="collapsible-entry d-flex" v-for="(l2, l2index) in b.restriction" v-if="isEntry(b2index,directionId,uindex,l2.crossStreet.value, l2index)" :key="'blr2lindex'+l2index+renderCounter">
										<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index, uindex, l2.crossStreet.value)"></div>
										<div class="flex-grow-1 ">
											<div class="d-flex collapsible-entry__title-wrapper">
												<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId, l2.crossStreet.value)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span> {{LaneClosureRequest.getRestrictionTypeText(restrictionTypeId)}} onto <span>{{l2.crossStreet.value}}</span></a></div>
												<div class="collapsible-entry__map-button">
													<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId, l2.crossStreet.value)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>
<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'

import Vue from 'vue'

export default {
	name: 'ViewLaneClosureRequestBlockRestrictionListing',
	props: ['value', 'preset', 'restrictionTypeId', 'directionId', 'expand', 'uniqueRestrictions', 'canReport'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			renderCounter: 0,
			backup: {},
			showPanel: false
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
	watch: {

	},
	computed: {
		getNavTitle() {
			return "Placing Turn Restrictions";
		},
		getModalTitle() {
			return LaneClosureRequest.getDirectionText(this.directionId) + " " + LaneClosureRequest.getRestrictionTypeText(this.restrictionTypeId);
		},
		entries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.restriction) {
					for (x = 0; x < entry.restriction.length; x++) {
						if (entry.restriction[x].restrictionTypeId.value == that.restrictionTypeId &&
							entry.restriction[x].directionId.value == that.directionId) {
							return true;
						}
					}
				}
				return false;
			})
		},
		nonEntries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.restriction) {
					for (x = 0; x < entry.restriction.length; x++) {
						if (entry.restriction[x].restrictionTypeId.value == that.restrictionTypeId &&
							entry.restriction[x].directionId.value == that.directionId) {
							return false;
						}
					}
				}
				return true;
			})
		},
	},
	methods: {
		getInEffectTitle() {
			var texts = [];
			var hasBlocks = false;

			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					for (var x = 0; x < this.value[index].restriction.length; x++) {
						if (this.value[index].restriction[x].restrictionTypeId.value == this.restrictionTypeId &&
							this.value[index].restriction[x].directionId.value == this.directionId) {
							if (texts["" + this.value[index].restriction[x].inEffect.value]) {} else {
								texts["" + this.value[index].restriction[x].inEffect.value] = 0;
							}
							hasBlocks = true;
							texts["" + this.value[index].restriction[x].inEffect.value]++;
						}
					}
				}
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				html += "<div class='status-circle r-in-place'>" + texts["1"] + "</div>";
			}
			if (texts["0"] > 0) {
				// open
				html += "<div class='status-circle r-removed'>" + texts["0"] + "</div>";
			}
			if (texts["null"] > 0) {
				// not reported
				// html += "<div class='status-circle r-not-reported'>" + texts["null"] + "</div>";
				html += "<div class='status-circle r-in-place'>" + texts["null"] + "</div>";
			}

			if (!hasBlocks) {
				html = "<div>NO BLOCKS</div>";
			}
			return html;
		},
		getInEffectText(index, restrictionIndex) {
			if (this.value) {
				if (this.value[index]) {
					return LaneClosureRequest.getRestrictionInEffectText(this.value[index].restriction[restrictionIndex].inEffect.value);
				}
			}
			return null;
		},
		getInEffectIcon(index, uindex, streetName) {
			var texts = [];
			if (this.value) {
				for (var x = 0; x < this.value[index].restriction.length; x++) {
					if (
						this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
						this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
						this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value &&
						this.value[index].restriction[x].crossStreet.value == streetName
						) {
						if (texts["" + this.value[index].restriction[x].inEffect.value]) {} else {
							texts["" + this.value[index].restriction[x].inEffect.value] = 0;
						}
						texts["" + this.value[index].restriction[x].inEffect.value]++;
					}
				}
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				// html += "<div class='status-circle-solid r-in-place'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-close.svg" alt="" />';
			}
			if (texts["0"] > 0) {
				// open
				// html += "<div class='status-circle-solid r-removed'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-open.svg" alt="" />';
			}
			if (texts["null"] > 0) {
				// not reported
				// html += "<div class='status-circle-solid r-not-reported'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-close.svg" alt="" />';
			}
			return html;
		},
		classes: function(index) {
			if (this.isEntry(index)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		flexClasses: function(index) {
			// if (this.isEntry(index)) {
				return "d-flex collapsible-entry";
			// } else {
				// return "d-flex pt-1 pb-0";
			// }
		},

		getPeakReasonText(index) {
			let html = "";
			if (this.value) {
				if (this.preset[0].restriction[index]) {
					html = LaneClosureRequest.getRestrictionPeakIdText(this.preset[0].restriction[index].peakId.value);
					if (this.preset[0].restriction[index].peakId.value == 6 || this.preset[0].restriction[index].peakId.value == 13 || this.preset[0].restriction[index].peakId.value == 19) {
						html += "<br/>" + this.preset[0].restriction[index].peakReason.value;
					}
				}
			}
			return html;

		},

		hasEntry(index, directionId, uindex, restrictions) {
			let result = false;
			if(restrictions) {
				restrictions.forEach((value, key) => {
					result = false;
					if(this.isEntry(index, directionId, uindex, value.crossStreet.value, key)) {
						result = true;
					}
				})
			}
			return result;
		},



		isEntry: function(index, directionId,uindex, streetName, l2index) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						// for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[l2index].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[l2index].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.directionId == this.preset[0].restriction[uindex].directionId.value &&
								this.directionId == this.value[index].restriction[l2index].directionId.value &&
								this.value[index].restriction[l2index].peakId.value == this.preset[0].restriction[uindex].peakId.value &&
								this.value[index].restriction[l2index].crossStreet.value == streetName
							) {
								return true;
							}
						// }
					}
				}
			}
			return false;
		},


		canBeAdded: function(index, uindex) {
			if (this.value) {
				if (this.preset[0].restriction[uindex]) {
					if (this.value[index]) {
						for (var x = 0; x < this.value[index].restriction.length; x++) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.directionId == this.preset[0].restriction[uindex].directionId.value &&
								this.directionId == this.value[index].restriction[x].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value
							) {
								// console.log("===================");
								// console.log(this.preset[0].restriction[uindex]);
								// console.log(this.value[index].restriction[x]);
							// b2index,directionId,uindex,l2.crossStreet.value, l2index
								return true;
							}
							/*
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.preset[0].restriction[uindex].restrictionTypeId.value &&
								this.value[index].restriction[x].directionId.value == this.preset[0].restriction[uindex].directionId.value &&
								this.value[index].restriction[x].peakId.value == this.preset[0].restriction[uindex].peakId.value
							) {
								return true;
							}
							*/
						}
					}
				}
			}
			return false;
			// if (LaneClosureRequest.hasTrafficLaneInDirection(this.preset[0].restriction[uindex].restrictionTypeId.value,  this.value[index].directionId)) {
			// 	return true;
			// }

			if (LaneClosureRequest.areDirectionsEquivalent(this.preset[0].restriction[uindex].directionId.value,this.value[index].directionId)) {
				return true;
			}

			return false;
		},

		hasEntries: function(uniqueIndex) {
			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					for (var x = 0; x < this.value[index].restriction.length; x++) {
						if (this.uniqueRestrictions[uniqueIndex]) {
							if (
								this.value[index].restriction[x].restrictionTypeId.value == this.restrictionTypeId &&
								this.value[index].restriction[x].directionId.value == this.directionId &&
								this.uniqueRestrictions[uniqueIndex].directionId == this.directionId &&
								this.uniqueRestrictions[uniqueIndex].restrictionTypeId == this.restrictionTypeId &&
								this.value[index].restriction[x].peakId.value == this.uniqueRestrictions[uniqueIndex].peakId &&
								this.value[index].restriction[x].peakReason.value == this.uniqueRestrictions[uniqueIndex].peakReason
							) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},

		switchId(prefix, block, id) {
			return prefix + "-" + block + "-" + id;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		editBlock: function(id) {
			Vue.prototype.$bus.$emit("block:edit-restriction", id);
		},
		showOnMap: function(id,streetName) {
			Vue.prototype.$bus.$emit("block:show-on-map", {id, type: "restriction", laneId: this.laneId, streetName:streetName});
		},
		onReview: function() {
			Vue.prototype.$bus.$emit("block:list-expand-restriction", { restrictionTypeId: this.restrictionTypeId, directionId: this.directionId, expand: !this.expand });
		},
		onApply: function() {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("block:list-expand-restriction", { restrictionTypeId: that.restrictionTypeId, directionId: that.directionId, expand: !that.expand });
			}, 250);
		},
		onReport() {
			Vue.prototype.$bus.$emit("block:report-restriction", null);
		},
		onSwipeRight() {
			if (this.showPanel) {
				this.showPanel = false;
				setTimeout(() => {
					let that = this;
					Vue.prototype.$bus.$emit("block:list-expand-restriction", { restrictionTypeId: that.restrictionTypeId, directionId: that.directionId, expand: !that.expand });
				}, 250);
			}
		},
		onToggleExpand: function() {
			Vue.prototype.$bus.$emit("block:list-expand-restriction", { restrictionTypeId: this.restrictionTypeId, directionId: this.directionId, expand: !this.expand });
		},
	}
}
</script>